import { useContext } from 'react';
import { ToastsContext } from '../context/toasts-context';

export function useToast() {
  const toastsContext = useContext(ToastsContext);
  return toastsContext;
}

export default useToast;
